var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-l box",style:({animationPlayState:!_vm.active ? 'running' : 'paused'}),on:{"mouseover":_vm.mouseover,"mouseleave":_vm.mouseleave}},_vm._l((_vm.anliList),function(item,i){return _c('el-image',{key:i,staticStyle:{"width":"300px","margin-left":"10px","margin-right":"10px"},attrs:{"src":item.url}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }